export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/comment-dots.2bd4405f.svg","height":14,"width":16,"blurWidth":0,"blurHeight":0};